<template>
  <ioc-form :option="detailOption"
            v-model="alarmDetail">
    <template slot-scope="scope"
              slot="commonAlarmTypeLabel">
      <span>{{scope.value}}</span>
    </template>

    <template slot-scope="scope"
              slot="buildingName">
      <span>{{ scope.value || $t('realTimeAlarm.label.noDatas') }}</span>
    </template>
    <!--一键求救-->
    <template slot-scope="scope"
              slot="alarmName">
      <span :title="scope.value">{{ scope.value }}</span>
    </template>
    <template slot-scope="scope"
              slot="alarmTypeLabel">
      <span>{{ scope.value}}</span>
    </template>
    <template slot-scope="scope"
              slot="alarmSubType">
      <span>{{ scope.value | dic('SENU103')}}</span>
    </template>
    <template slot-scope="scope"
              slot="alarmLevel">
      <span>{{ scope.value | showLevel }}</span>
    </template>
    <template slot-scope="scope"
              slot="alarmTime">
      <span>{{ scope.value | showTime }}</span>
    </template>
    <template slot-scope="scope"
              slot="deviceWorkGroupName">
      <span>{{ scope.value }}</span>
    </template>
    <template slot-scope="scope"
              slot="desc">
      <div class="word-break-all">{{ scope.value || $t('realTimeAlarm.label.noDatas') }}</div>
    </template>
    <template slot-scope="scope"
              slot="deviceName">
      <span>{{ scope.value }}</span>
    </template>
    <template slot-scope="scope"
              slot="groupName">
      <span>{{ scope.value }}</span>
    </template>
  </ioc-form>
</template>
<script>
import column from '../options/alarmDetail'
import { Dic, Dates } from '$utils'
export default {
  filters: {
    showType (alarmType, item) {
      if (alarmType) {
        const value = Dic.findByValue(`SENU00400${alarmType[0]}`, alarmType)
        return value
      }
    },
    showTime (time, item) {
      return Dates.dayjs(Number(time)).format('YYYY-MM-DD HH:mm:ss')
    },
    showLevel (alarmLevel, item) {
      if (alarmLevel) {
        return Dic.findByValue('SENU017', alarmLevel);
      }
    },
  },
  props: {
    detail: {
      type: Object,
      default: () => {
        return null
      }
    }
  },
  watch: {
    // detail: {
    //   handler (newVal, oldVal) {
    //     if (newVal) {
    //       this.alarmDetail.alarmType = newVal.alarmType
    //       this.alarmDetail.alarmTime = newVal.alarmTime
    //       this.alarmDetail.groupName = newVal.groupName
    //     }
    //   },
    //   immediate: true,
    //   deep: true
    // }

    detail: {
      handler (newVal, oldVal) {
        if (newVal) {
          this.alarmDetail = newVal;
          this.initDetail();
        }
      },
      immediate: true,
      deep: true
    }
  },
  data () {
    return {
      detailOption: {
        labelWidth: 100,
        menuBtn: false,
        gutter: 14,
        column: []
      },
      alarmDetail: this.detail,
    }
  },
  mounted () {
  },
  methods: {
    initDetail () {
      if (this.detail.subSystem === '12') {
        // 一键求救
        this.detailOption.column = column.columnHelp()
      }else if(this.detail.subSystem === '5'){
       this.detailOption.column = column.columnFireWorks()
      }
    },
    alarmLevel () {
      return Dic.findByValue('SENU017', this.detail.alarmLevel);
    },
  }
}
</script>